<script setup lang="ts">
const props = defineProps<{
  rating: number
}>()

const fullStars = Math.floor(props.rating)
const hasHalf = props.rating % 1 !== 0
const emptyStars = 5 - Math.ceil(props.rating)
const partialFill = Math.round((props.rating % 1) * 100)

const stars = [
  ...Array(fullStars).fill('full'),
  ...(hasHalf ? ['partial'] : []),
  ...Array(emptyStars).fill('empty')
]
</script>

<template>
  <div class="flex items-center space-x-2">
    <template v-for="(type, index) in stars" :key="index">
      <SvgIcon
        v-if="type === 'full'"
        class="!size-6 md:!size-8"
        name="outlined/star-full"
      />
      <SvgIcon
        v-else-if="type === 'empty'"
        class="!size-6 md:!size-8"
        name="outlined/star-empty"
      />
      <div v-else class="relative !size-6 md:!size-8">
        <SvgIcon
          class="absolute inset-0 !size-6 md:!size-8"
          name="outlined/star-empty"
        />
        <div
          class="absolute inset-0 overflow-hidden"
          :style="`width: ${partialFill}%`"
        >
          <SvgIcon
            class="!size-6 md:!size-8"
            name="outlined/star-full"
          />
        </div>
      </div>
    </template>
  </div>
</template>
